import React from "react";
import { Pagination } from "antd";

interface TablePaginationProps {
  currentPage: number;
  pageSize: number;
  totalItems: number;
  filteredItems: number;
  isFiltered: boolean;
  onPageChange: (page: number, pageSize?: number) => void;
  onPageSizeChange: (current: number, size: number) => void;
  entityName: string;
  loading?: boolean;
}

const TablePagination: React.FC<TablePaginationProps> = ({
  currentPage,
  pageSize,
  totalItems,
  filteredItems,
  isFiltered,
  onPageChange,
  onPageSizeChange,
  entityName,
  loading = false
}) => {
  const effectiveTotal = isFiltered ? filteredItems : totalItems;
  const effectiveCount = isFiltered ? filteredItems : totalItems;
  
  const startItem = effectiveTotal > 0 ? (currentPage - 1) * pageSize + 1 : 0;
  const endItem = Math.min(currentPage * pageSize, effectiveTotal);

  return (
    <>

      <div className="d-flex align-items-start justify-content-between mt-2">
        <p className="text-muted">
          {effectiveTotal > 0 ? (
            <>Showing {startItem}-{endItem} of {effectiveCount} {entityName}</>
          ) : (
            <>No {entityName} found</>
          )}
          {isFiltered && <span className="text-primary"> (filtered)</span>}
        </p>

        <Pagination
          current={currentPage}
          pageSize={pageSize}
          total={effectiveTotal}
          showSizeChanger={false}
          showQuickJumper={false}
          onChange={onPageChange}
          onShowSizeChange={onPageSizeChange}
          hideOnSinglePage={true}
          disabled={loading}
          className="custom-pagination"
        />
      </div>
    </>
  );
};

export default TablePagination;